import React from 'react'
import Select from "react-select";

function AgentDetailedBreadCrumbs(props) {
  const {
    handleAgentChange,
    agentList,
    selectedAgent,
    handleAgentInputChange,
    goBackToInsights,
  } = props;
  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      padding: "0",
      border: "0",
      fontSize: "0.85625rem",
      minWidth: "10rem",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "calc(2.0em + 0.5rem + 2px)",
      minHeight: "calc(2.0em + 0.5rem + 2px)",
      fontSize: "0.85625rem",
      borderColor: "transparent",
      boxShadow: "none",
      transition:
        "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      ":hover": {
        borderColor: state.isFocused ? "#66afe9" : "#d8dbe0",
        boxShadow: state.isFocused
          ? "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)"
          : "inset 0 1px 1px rgba(0, 0, 0, 0.075)",
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      marginTop: "0",
      marginLeft: "6px",
      padding: "0",
      border: "0",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      marginTop: "0",
      padding: "0",
      border: "0",
      width: "16px",
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      marginTop: "0",
      padding: "0",
      border: "0",
      width: "16px",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      paddingRight: "4px",
      border: "0",
    }),
  };
  return (
    <div>
      <span className="d-flex align-items-center">
        <span
          onClick={goBackToInsights}
          style={{
            color: "#382d62",
            cursor: "pointer",
            marginRight: "1rem",
            fontWeight: 500,
          }}
        >
          Insights
        </span>
        <span style={{ marginRight: "0.5rem" }}>&#9654;</span>
        <span className="header-insights-agent-selection">
          <Select
            value={{ label: selectedAgent.name, value: selectedAgent.id }}
            options={agentList === null ? [] : agentList}
            styles={customStyles}
            onChange={handleAgentChange}
            onInputChange={handleAgentInputChange}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary50: "transparent",
                primary25: "transparent",
                primary: "#2c3687",
              },
            })}
          />
        </span>
      </span>
    </div>
  );
}

export default AgentDetailedBreadCrumbs;
